import { kOCNTextColor } from "../constants";
import { QTextEdit } from "./QTextEdit";

export class QNumberEdit extends QTextEdit {
  constructor() {
    super();
    this.fIntegerOnly = false;
    this.fDecimalChar = ".";
    this.fActiveSelection = true;
  }

  SetIntegerOnly(integerOnly) {
    this.fIntegerOnly = integerOnly;
  }

  SetDecimalChar(decChar) {
    this.fDecimalChar = decChar;
  }

  TEFilterInput(inputString) {
    var n = inputString.length;
    for (var i = 0; i < n; i++) {
      var keyChar = inputString[i];
      var keyOK =
        (keyChar >= "0" && keyChar <= "9") || (keyChar == this.fDecimalChar && !this.fIntegerOnly);
      if (!keyOK) return true;
    }

    return false;
  }

  DoSetEnabled(enabled) {
    if (enabled) this.SetBorderColor(kOCNTextColor);
    else this.SetBorderColor("#DDDDDD");
  }
}
